/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

export { ComponentDetailModal } from './component-detail-modal';
export { GeneralTab } from './general-tab';
